import {FormControl, FormGroup} from '@angular/forms';

import {BaseControl} from '../../../shared/classes';

import {EditAccountAddUserControl} from '../../../../assets/descriptors';

export class EditTradingAccountAddUserForm {
    public form: FormGroup;
    public control: BaseControl;

    constructor() {
        this.control = null;
    }

    initForm(): void {
        this.form = new FormGroup({});
        this.control = EditAccountAddUserControl();
        this.form.addControl(this.control.name, new FormControl(this.control.value, this.control.validators));
    }
}
